{
  "nav": {
    "home": "Start",
    "tutorials": "Tutorials",
    "contact": "Kontakt",
    "logout": "Abmelden",
    "logoAlt": "DinLabel",
    "download": "Herunterladen",
    "buy": "Kaufen",
    "login": "Anmelden",
    "myAccount": "Mein Konto",
    "settings": "Einstellungen",
    "distributorPortal": "Händlerportal"
  },
  "settings": {
    "title": "Einstellungen",
    "language": "Sprache",
    "languageDescription": "Wählen Sie die Sprache der Anwendung. Standardmäßig wird die Browsersprache verwendet.",
    "languageBrowser": "Browsersprache verwenden",
    "languageEnglish": "Englisch",
    "languageSpanish": "Spanisch",
    "languageGerman": "Deutsch",
    "languageFrench": "Französisch"
  },
  "offline": {
    "title": "Offline",
    "message": "Die Anwendung kann keine Verbindung zum Server herstellen :( !!"
  },
  "dialogs": {
    "apiError": "API-Fehler",
    "confirmYes": "Ja",
    "cancel": "Abbrechen",
    "send": "Senden"
  },
  "portal": {
    "pageTitle": "Händlerportal",
    "actions": "Aktionen",
    "authorized": "Autorisiert",
    "pending": "Genehmigung ausstehend",
    "buyLicenses": "Lizenzen kaufen",
    "pendingApproval": "Ihr Händlerantrag wurde noch nicht genehmigt – bei Fragen können Sie {{email}} kontaktieren. Dieser Vorgang sollte nicht länger als 2 Werktage dauern.",
    "distributorInfo": "Informationen für Händler",
    "loading": "Händlerinformationen werden geladen…",
    "loadError": "Händlerinformationen konnten nicht geladen werden."
  },
  "licenses": {
    "noneAvailable": "Sie haben derzeit keine Lizenzen zum Senden verfügbar.",
    "availableCount": "Sie haben {{count}} Lizenzen zum Senden verfügbar.",
    "boughtAndSent": "Insgesamt haben Sie {{bought}} Lizenzen gekauft und {{sent}} Lizenzen gesendet",
    "statAvailable": "Zum Senden verfügbar",
    "statBought": "Gekauft",
    "statSent": "Gesendet",
    "sentHistory": "Gesendete Lizenzen",
    "activatedYes": "Aktiviert",
    "buyTitle": "Händlerportal – Lizenzen kaufen",
    "buyLoading": "Wird geladen…",
    "buyLoadError": "Händlerinformationen konnten nicht geladen werden.",
    "buyIntro": "Geben Sie an, wie viele Lizenzen Sie kaufen möchten – der Händlerpreis beträgt {{price}} Pesos. Händler können DinLabel zu einem angemessenen Preis verkaufen; unser empfohlener Preis beträgt {{recommended}} Pesos.",
    "licenseCountLabel": "Anzahl der Lizenzen",
    "costSummary": "Die Kosten für {{count}} Lizenzen betragen {{cost}} Pesos + Steuern.",
    "buyButton": "{{count}} Lizenzen kaufen",
    "sendTitle": "Lizenz senden",
    "resendConfirm": "Möchten Sie die Lizenz erneut an {{email}} senden?",
    "sendPrompt": "Geben Sie die E-Mail-Adresse ein, an die gesendet werden soll",
    "emailPlaceholder": "email@beispiel.com",
    "errorTitle": "Fehler!",
    "sendError": "Beim Senden der Lizenz ist ein Fehler aufgetreten {{error}}",
    "resentTitle": "Lizenz erneut gesendet!",
    "resentMessage": "Die Lizenz wurde erneut an {{email}} mit Kopie an {{cc}} gesendet",
    "sentTitle": "Lizenz gesendet!",
    "sentMessage": "Die Lizenz wurde an {{email}} mit Kopie an {{cc}} gesendet",
    "sendToEmail": "Lizenz per E-Mail senden...",
    "recipient": "Lizenzempfänger",
    "date": "Datum",
    "sent": "Gesendet",
    "activated": "Aktiviert",
    "notActivated": "Noch nicht aktiviert",
    "resend": "Lizenz erneut senden"
  },
  "register": {
    "title": "Händler werden",
    "intro": "Um auf das DinLabel-Händlerportal zuzugreifen, müssen Sie sich zuerst registrieren:",
    "company": "Firma",
    "companyPlaceholder": "Firmenname",
    "phone": "Telefon",
    "phonePlaceholder": "Telefon",
    "phoneDescription": "Achten Sie darauf, die Ländervorwahl anzugeben, z. B. +49 30...",
    "street": "Straße",
    "street1Placeholder": "Straße 1",
    "street2Placeholder": "Straße 2",
    "number": "Nummer",
    "city": "Stadt",
    "state": "Bundesland",
    "country": "Land",
    "zip": "Postleitzahl",
    "rfc": "Steuer-ID",
    "nextSteps": "Sie erhalten eine E-Mail mit den nächsten Schritten",
    "submit": "Absenden"
  },
  "faq": {
    "qGoogleAccount": "Benötige ich ein Google-Konto, um DINLabel-Händler zu werden?",
    "aGoogleAccount": "Ja, Sie benötigen ein Google-Konto. Wenn Sie bereits eines haben, können Sie sich damit im Händlerportal anmelden.",
    "qRequirements": "Was brauche ich, um DINLabel-Händler zu werden?",
    "aRequirementsBefore": "Registrieren Sie sich als Händler im",
    "aRequirementsLink": "Händlerportal",
    "aRequirementsAfter": "und warten Sie auf die Bestätigungs-E-Mail, die Sie als DINLabel-Händler autorisiert.",
    "qAnyoneCanSell": "Kann jede Person oder jedes Unternehmen DINLabel verkaufen?",
    "aAnyoneCanSell": "Ja, Sie müssen sich nur im DINLabel-Händlerportal registrieren und die Bestätigungs-E-Mail erhalten.",
    "qHowManyDistributors": "Wie viele Händler kann es bei DINLabel geben?",
    "aHowManyDistributors": "Es gibt keine Begrenzung.",
    "qDistributorCost": "Was kostet eine DINLabel-Lizenz für einen Händler?",
    "aDistributorCost": "112 USD zuzüglich Steuern pro Lizenz.",
    "qRecommendedPrice": "Was ist der empfohlene Verkaufspreis vom Händler an seine Kunden für eine DINLabel-Lizenz?",
    "aRecommendedPrice": "Der Händler legt den Preis fest; es gibt keinen festen Preis. Wir empfehlen einen Verkaufspreis von 160 USD zuzüglich Steuern. Der Direktpreis im DINLabel-Portal ohne Händler beträgt 180 USD.",
    "qWhereToBuy": "Wo kann ein Endnutzer eine DINLabel-Lizenz kaufen?",
    "aWhereToBuyBefore": "Sie können sie bei einem Händler oder direkt im Portal kaufen",
    "qHowBuyAsDistributor": "Als Händler, wie kaufe ich DINLabel-Lizenzen?",
    "aHowBuyAsDistributorBefore": "Über das Händlerportal im Bereich Lizenzen kaufen. Siehe das Tutorial",
    "aHowBuyAsDistributorLink": "wie man Lizenzen kauft.",
    "qMinimumLicenses": "Als Händler, wie viele Lizenzen muss ich mindestens kaufen, um sie später an meine Kunden zu verkaufen?",
    "aMinimumLicenses": "Es gibt kein Minimum; Sie können ab 1 Lizenz kaufen.",
    "qHowDeliver": "Als Händler, wie liefere ich eine DINLabel-Lizenz an meinen Kunden?",
    "aHowDeliverBefore": "Über das Händlerportal im Bereich",
    "aHowDeliverSendLink": "Lizenzen senden",
    "aHowDeliverMiddle": "; siehe das",
    "aHowDeliverTutorialLink": "Tutorial zum Senden von Lizenzen.",
    "qHowLongPurchase": "Wie lange dauert es, als Händler eine Lizenz zu kaufen und an den Kunden zu liefern?",
    "aHowLongPurchase": "Wenn Sie bereits als Händler registriert sind, können Kauf und Lizenzlieferung in wenigen Minuten erfolgen.",
    "qHowLongToSell": "Als Händler, wie lange habe ich Zeit, die im Portal gekauften Lizenzen zu verkaufen?",
    "aHowLongToSell": "Händlerlizenzen verfallen nicht. Beim Kauf werden sie Ihrem Lizenzbestand hinzugefügt und können jederzeit verwendet werden.",
    "qHowManyAvailable": "Wie kann ich als Händler sehen, wie viele Lizenzen ich habe?",
    "aHowManyAvailableBefore": "Wenn Sie das DINLabel-",
    "aHowManyAvailableLink": "Händlerportal",
    "aHowManyAvailableAfter": " öffnen, zeigt der erste Bildschirm Ihren Bestand an zum Senden verfügbaren Lizenzen.",
    "qSoldLicenses": "Wie kann ich sehen, welche Lizenzen ich verkauft habe und an wen?",
    "aSoldLicensesBefore": "Über das DINLabel-Händlerportal unter",
    "aSoldLicensesLink": "Details anzeigen",
    "qTryBefore": "Kann ich DINLabel ausprobieren, bevor ich Händler werde?",
    "aTryBeforeBefore": "Ja, Sie können eine Demo unter",
    "aTryBeforeAfter": "herunterladen und ausprobieren.",
    "qMainFaq": "Gibt es FAQs (häufig gestellte Fragen) im DINLabel-Portal?",
    "aMainFaqBefore": "Unter",
    "aMainFaqAfter": "finden Sie die häufigsten Fragen zur Nutzung des DINLabel-Systems.",
    "qTutorials": "Gibt es Tutorials zur Nutzung von DINLabel?",
    "aTutorialsBefore": "Unter",
    "aTutorialsAfter": "finden Sie alle benötigten Tutorials zur Nutzung von DINLabel.",
    "qSupport": "Habe ich als Händler technischen Support?",
    "aSupport": "Per E-Mail; siehe das Ende dieser FAQ.",
    "qOtherQuestion": "Ich habe eine Frage, die nicht auf der Liste steht. Was kann ich tun?",
    "aOtherQuestionBefore": "Wir helfen Ihnen gerne. Gehen Sie zu",
    "aOtherQuestionLink": "Kontakt",
    "aOtherQuestionAfter": ", senden Sie Ihre Fragen, und wir antworten Ihnen gerne."
  },
  "tutorials": {
    "title": "Tutorials",
    "alsoSeeFaqBefore": "Sie können auch die",
    "alsoSeeFaqLink": "FAQ",
    "sendLicenseTutorial": "Tutorial: So senden Sie eine Lizenz aus dem Händlerportal",
    "iframeTitle": "Tutorial Lizenz senden"
  },
  "home": {
    "welcome": "Willkommen, {{email}}",
    "error": "Fehler"
  },
  "userLicenses": {
    "hasLicense": "Sie haben bereits eine DinLabel-Lizenz.",
    "noLicense": "Sie haben Ihre DinLabel-Lizenz noch nicht erworben",
    "buyHere": "Hier kaufen"
  },
  "app": {
    "documentTitle": "DinLabel"
  },
  "signin": {
    "title": "Anmelden",
    "intro": "Melden Sie sich mit Ihrem Google-Konto an, um fortzufahren.",
    "withGoogle": "Mit Google anmelden",
    "agreePrefix": "Indem Sie fortfahren, stimmen Sie unserer",
    "privacyLink": "Datenschutzerklärung und den Nutzungsbedingungen",
    "alreadySignedIn": "Sie sind bereits angemeldet",
    "signedInAs": "Angemeldet als {{email}}",
    "continue": "Weiter",
    "debugSignInUrl": "Anmelde-URL"
  },
  "applogin": {
    "title": "In DinLabel fortfahren",
    "intro": "Fahren Sie fort, um die Anmeldung in der Desktop-App abzuschließen.",
    "signedInAs": "Sie sind angemeldet als {{email}}.",
    "continue": "Weiter",
    "switchAccount": "Anderes Konto verwenden",
    "redirecting": "Weiterleitung zur Anmeldung…",
    "invalidTitle": "Ungültiger Anmeldelink",
    "invalidBody": "Diese Seite wird von der DinLabel-Desktop-App geöffnet. Bitte starten Sie die Anmeldung in der Anwendung."
  },
  "marketing": {
    "headline": "Professionelle Software für Etikettendesign",
    "slogan": "Entwerfen und drucken Sie Etiketten auf Thermodruckern — Zebra und mehr — mit Barcodes, variablen Daten und Seriennummern.",
    "featureNumbers": "Seriennummern",
    "featureImages": "Bilder",
    "featureVariable": "Variable Daten",
    "featureQr": "2D-Barcode",
    "featureText": "Text",
    "featureBarcode": "Barcode",
    "featuresTitle": "Alles, was Sie auf einem Etikett brauchen",
    "featuresSubtitle": "Erstellen Sie professionelle Etiketten mit den Werkzeugen, auf die Druckereien und Lagerhäuser täglich setzen.",
    "printersTitle": "Für Thermoetikettendrucker gemacht",
    "printersSubtitle": "DinLabel funktioniert mit den Thermo- und Industriedruckern, die Betriebe bereits nutzen — darunter Zebra, Honeywell, TSC, SATO und andere Windows-kompatible Etikettendrucker.",
    "printersBrands": "Zebra · Honeywell · TSC · SATO · und mehr",
    "printersNote": "Drucken Sie auf Desktop- und industriellen Thermodruckern über Ihre normalen Windows-Druckertreiber. Ideal für Rollen, Bögen, Versandetiketten und Produktionslinien.",
    "whyTitle": "Warum DinLabel?",
    "whyBody": "DinLabel hilft Ihnen, schnell professionelle Etiketten für Thermodrucker, Rollen, Bögen und industrielle Geräte zu erstellen — ohne Enterprise-Softwarepreise.",
    "tryTitle": "DinLabel-Demo ausprobieren",
    "trySubtitle": "Laden Sie die Demo herunter, verbinden Sie Ihren Thermodrucker und beginnen Sie in Minuten mit dem Etikettendesign.",
    "needHelp": "Brauchen Sie Hilfe?",
    "customerService": "Kundenservice",
    "customerServiceText": "Kontaktieren Sie uns per E-Mail – wir helfen Ihnen gerne.",
    "tutorialsText": "Schritt-für-Schritt-Video-Tutorials für jede Funktion."
  },
  "footer": {
    "tagline": "Professionelles Etikettendesign für Thermodrucker — Zebra und mehr.",
    "privacy": "Datenschutz & Bedingungen",
    "copyright": "© {{year}} DinLabel"
  },
  "install": {
    "title": "Herunterladen",
    "intro": "Installieren Sie DinLabel unter Windows und beginnen Sie in Minuten mit dem Design von Etiketten für Thermodrucker — einschließlich Zebra und anderer Windows-Etikettendrucker.",
    "windowsNote": "Windows-Installer (.exe). Funktioniert unter Windows 7 und neuer.",
    "requirements": "Systemanforderungen",
    "reqWindows": "Jede Windows-Version ab Windows 7",
    "reqInternet": "Internetzugang",
    "reqRam": "1 GB RAM",
    "reqDisk": "10 GB Festplattenspeicher",
    "freeTag": "Demo-Version",
    "freeText": "Die Demo-Version enthält ein Wasserzeichen auf gedruckten Etiketten.",
    "paidTitle": "Vollversion",
    "paidText": "Keine Wasserzeichen — bereit für den Produktionsdruck.",
    "buyApp": "Anwendung kaufen",
    "orDistributor": "Lieber über einen Partner kaufen?",
    "distributorsLink": "Händler anzeigen",
    "emailModalTitle": "Demo herunterladen",
    "emailModalIntro": "Geben Sie Ihre E-Mail-Adresse ein, um die DinLabel-Demo herunterzuladen.",
    "emailLabel": "E-Mail",
    "emailSubmit": "Herunterladen",
    "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "emailSubmitError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "purchasedIntro": "Laden Sie DinLabel herunter und installieren Sie es, um Ihre Vollversion zu nutzen.",
    "signInTitle": "So melden Sie sich an",
    "signInStep1": "Laden Sie DinLabel mit der Schaltfläche oben herunter und installieren Sie es.",
    "signInStep2": "Öffnen Sie DinLabel.",
    "signInStep3": "Wählen Sie Anmelden / Registrieren im Menü.",
    "signInStep4": "Melden Sie sich mit demselben Google-Konto an, mit dem Sie gekauft haben. Nach der Anmeldung nutzen Sie die Vollversion von DinLabel."
  },
  "fullTutorials": {
    "title": "Tutorials",
    "intro": "Schritt-für-Schritt-Videos, die Ihnen helfen, DinLabel zu nutzen, zu drucken und optimal einzusetzen.",
    "howToRoll": "So erstellen Sie ein Etikett auf einer Rolle",
    "howToSheet": "So erstellen Sie ein Etikett auf einem Bogen",
    "howTo3Across": "So erstellen Sie 3-bahnige Etiketten",
    "howToText": "So fügen Sie Text hinzu",
    "howToShapes": "So fügen Sie Formen hinzu",
    "howToImages": "So fügen Sie Bilder hinzu",
    "howToBarCodes": "So fügen Sie Barcodes hinzu",
    "howToQR": "So fügen Sie QR-Codes hinzu",
    "howToPrint": "So drucken Sie",
    "howToConsecutive": "So verwenden Sie fortlaufende Nummern",
    "howToDataBase": "So verwenden Sie Datenbanken",
    "howToBuy": "So kaufen Sie DinLabel",
    "alsoDistributor": "Händlerspezifische Tutorials finden Sie im Händlerportal.",
    "distributorLink": "Händlerportal öffnen"
  },
  "privacy": {
    "title": "Datenschutzerklärung und Nutzungsbedingungen",
    "eulaLink": "Endbenutzer-Lizenzvertrag",
    "policyLink": "Datenschutzerklärung",
    "note": "Die Datenschutzerklärung öffnet das lokalisierte statische HTML-Dokument.",
    "loading": "Wird geladen…",
    "eulaLoadError": "Die EULA konnte nicht geladen werden."
  },
  "distributors": {
    "title": "Händler"
  },
  "buyPage": {
    "title": "DinLabel kaufen",
    "intro": "Schalten Sie die Vollversion frei — ohne Wasserzeichen, bereit für Thermo- und Produktionsdruck auf Zebra und anderen Etikettendruckern.",
    "panelTitle": "Vollversion",
    "loading": "Checkout wird geladen…",
    "loadError": "Checkout konnte nicht gestartet werden. Bitte melden Sie sich an und versuchen Sie es erneut.",
    "errorTitle": "Etwas ist schiefgelaufen",
    "thanks": "Danke für den Kauf von DinLabel. Sie haben jetzt vollen Zugriff auf die App!",
    "checkAccount": "Kontostatus prüfen",
    "goToDownload": "Zur Download-Seite",
    "price": "USD ${{price}} + Steuern",
    "payWithCard": "Mit Karte bezahlen",
    "payError": "Weiterleitung zu Stripe Checkout fehlgeschlagen.",
    "adminTestMode": "Dies ist ein Admin-Benutzer, daher verwendet der Checkout Testmode-Informationen. Verwenden Sie die Kreditkarte '4242 4242 4242 4242'.",
    "debugToggleBought": "Nur für Admins: Debug: Bought umschalten",
    "toggleBoughtError": "Bought-Status konnte nicht umgeschaltet werden.",
    "orVia": "Andere Option bevorzugen?",
    "downloadDemo": "Eine voll funktionsfähige Demo herunterladen",
    "contactDistributor": "Einen Händler kontaktieren",
    "becomeDistributor": "Möchten Sie Händler werden?"
  },
  "userInfo": {
    "title": "Mein Konto",
    "detailsTitle": "Kontodaten",
    "quickLinks": "Schnelllinks",
    "userId": "Benutzer-ID",
    "email": "E-Mail-Adresse",
    "emailConfirmed": "E-Mail bestätigt",
    "confirmed": "Bestätigt",
    "notConfirmed": "Nicht bestätigt",
    "resend": "Erneut senden",
    "resentEmail": "Bestätigungs-E-Mail erneut an {{email}} gesendet",
    "resendError": "Bestätigungs-E-Mail konnte nicht erneut gesendet werden.",
    "version": "Anwendungsversion",
    "freeVersion": "Demo-Version",
    "fullVersion": "Vollversion",
    "buyApp": "Anwendung kaufen",
    "accountType": "Konto",
    "admin": "Admin-Portal",
    "openDistributorPortal": "Händlerportal öffnen"
  },
  "myLabels": {
    "title": "Meine Etiketten",
    "loading": "Wird geladen…",
    "loadError": "Etiketten konnten nicht geladen werden.",
    "empty": "Sie haben keine gespeicherten Etiketten.",
    "name": "Name",
    "date": "Datum",
    "view": "Anzeigen",
    "download": "Herunterladen",
    "back": "Zurück zu meinen Etiketten"
  },
  "admin": {
    "title": "Admin-Portal",
    "dataLink": "DinLabel Client-Analytics-Dashboard",
    "serverAnalyticsLink": "Server-Analytics-Dashboard",
    "fakeEmailLink": "Fake-E-Mails",
    "loading": "Wird geladen…",
    "loadError": "Admindaten konnten nicht geladen werden.",
    "totalUsers": "Benutzer insgesamt: {{count}}",
    "paidUsers": "Zahlende Benutzer: {{count}}",
    "users": "Benutzer",
    "distributors": "Händler",
    "payments": "Händlerzahlungen",
    "demoDownloaders": "Demo-Downloads",
    "authorize": "Autorisieren"
  },
  "fakeEmail": {
    "title": "Fake-E-Mails",
    "description": "Vorschau generierter E-Mail-Vorlagen mit Platzhalterdaten.",
    "distributorSignUp": "Händler-Anmeldung",
    "activationLink": "Aktivierung / E-Mail bestätigen",
    "sendEmailLicense": "Händler sendet Lizenz",
    "congratulationEmail": "Glückwunsch",
    "boughtLicensesMail": "Gekaufte Lizenzen",
    "demoDownloadThankYou": "Demo-Download Danke",
    "subject": "Betreff",
    "body": "Text",
    "loading": "Wird geladen…",
    "loadError": "Diese E-Mail konnte nicht geladen werden.",
    "backAdmin": "Zurück zur Administration",
    "testAddress": "Testadresse",
    "testAddressPlaceholder": "du@beispiel.com",
    "sendTest": "Test senden",
    "sendSuccess": "{{action}} an {{email}} gesendet",
    "sendError": "Test-E-Mail konnte nicht gesendet werden."
  }
}
